// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomDrawer_root__oNjEw","rightContent":"CustomDrawer_rightContent__S__lS"};